import { useEffect, useRef } from "react"

export const useDisableScroll = (reRender = false) => {
  const ref = useRef(null)

  useEffect(() => {
    const disableScroll = (e) => {
      e.preventDefault()
    }

    const targetDiv = ref.current

    if (targetDiv) {
      const handleWheel = disableScroll
      const handleTouchMove = disableScroll

      targetDiv.addEventListener("wheel", handleWheel, { passive: false })
      targetDiv.addEventListener("touchmove", handleTouchMove, { passive: false })

      return () => {
        targetDiv.removeEventListener("wheel", handleWheel)
        targetDiv.removeEventListener("touchmove", handleTouchMove)
      }
    }
  }, [ref, reRender])

  return { ref }
}